import { Slot } from '@radix-ui/react-slot';
import { clsx } from 'clsx';
import { type ComponentPropsWithRef, type ReactNode } from 'react';

import s from './TextEllipsis.module.css';

interface TextEllipsisProps extends ComponentPropsWithRef<'span'> {
  asChild?: boolean;
  children: ReactNode;
  className?: string;
}

export const TextEllipsis = (props: TextEllipsisProps) => {
  const { asChild = false, children, className, ...attrs } = props;

  if (!children) {
    return null;
  }

  const Component = asChild ? Slot : 'span';

  return (
    <Component className={clsx(s.ellipsis, className)} {...attrs}>
      {children}
    </Component>
  );
};
